/** Used to match template delimiters. */
var reInterpolate = /<%=([\s\S]+?)%>/g;

export default reInterpolate;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_reInterpolate.js
// module id = 1110
// module chunks = 67